import { render, staticRenderFns } from "./CollectionList.vue?vue&type=template&id=1d2d3b96&"
import script from "./CollectionList.vue?vue&type=script&lang=js&"
export * from "./CollectionList.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./CollectionList.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "278d8db0"
  
)

export default component.exports